export enum CheckEmailExistanceStatus
{
    ValidEmail = 1,
    EmailExist = 2,
    EmailExistButNotActivated = 3,
    AccountLocked = 4
}